import { useCallback, useMemo } from 'react';

import { Enum, EnumListKey, useAllEnums } from '~/data/enums';
import { useVisible } from '~/hooks/useVisible';
import { People } from '~/services/Http';
import { useGetCompensationsSummary } from '~/services/Http/hooks';

export interface UseMyCompensationWidgetOutput {
  loading: boolean;
  failedToLoad: boolean;
  myCompensationSummary?: People.CompensationsSummaryDto;
  isMyCompensationDialogOpen: boolean;
  openMyCompensationDialog: () => void;
  closeMyCompensationDialog: () => void;
  getSalaryFrequency: (code?: string) => Enum | undefined;
}

export const getCompensationsReqParams = { employeeId: 'me' };

export const useMyCompensationWidget = (): UseMyCompensationWidgetOutput => {
  const { getEnums } = useAllEnums();
  const salaryFrequencies = useMemo(
    () => getEnums(EnumListKey.EVENT_FREQUENCY),
    [getEnums],
  );
  const getSalaryFrequency = useCallback(
    (code?: string): Enum | undefined => {
      return !!code
        ? salaryFrequencies.find((e) => e.code === code)
        : undefined;
    },
    [salaryFrequencies],
  );

  const {
    data: myCompensationSummary,
    loading,
    failedToLoad,
  } = useGetCompensationsSummary(getCompensationsReqParams);
  const {
    isVisible: isMyCompensationDialogOpen,
    show: openMyCompensationDialog,
    hide: closeMyCompensationDialog,
  } = useVisible();

  return {
    loading,
    failedToLoad,
    myCompensationSummary,
    isMyCompensationDialogOpen,
    openMyCompensationDialog,
    closeMyCompensationDialog,
    getSalaryFrequency,
  };
};
